import http from "./http";
const api =  {
  // 登录
  getCaptcha(){
    return http.get('/manage/login/code?str='+Math.random())
  },
  checkCaptcha(param){
    return http.get('/manage/login/checkCode',param)
  },
  accountLogin(param){
    return http.post('/manage/login/login',param)
  },
  //首页
  getStatisticsData(param){
    return http.get('/manage/index/statistics',param)
  },
  getQueueList(param){
    return http.get('/manage/index/queue',param)
  },
  getMapData(param){
    return http.post('/manage/index/mapCity',param)
  },
  getLineData(param){
    return http.post('/manage/index/week',param)
  },
  // getSummaryData(param){
  //   return http.post('/manage/index/summary',param)
  // },
  getRoleSwitching(param){
    return http.post('/manage/index/roleSwitching',param)
  },
  getSwitchAccounts(param){
    return http.post('/manage/index/switchAccounts',param)
  },



  //新版 客户中心

    //进件数据
    getClientLists(param){
      return http.post('/manage/member/client',param)
    },
    getClientEdits(param){
      return http.get('/manage/member/edit',param)
    },
    getClientDetails({id}){
      return http.get('/manage/member/detail',{id})
    },
    //组件 - Salesperson 批量修改业务员
    getSalespersonList(param){
      return http.post('/manage/member/batch_list',param)
    },
    getUpdateBusiness(param){
      return http.post('/manage/member/batch_update',param)
    },
    //信息更新
    getClientInformationLists(param){
      return http.post('/manage/member/information_list',param)
    },
    addInformationImport(param){
      return http.post('/manage/member/information_import',param)
    },

    //组件 - survey 回访信息
    getClientSurvey(param){
      return http.get('/manage/member/survey',param)
    },
    addClientSurvey(param){
      return http.post('/manage/member/survey_add',param)
    },

    //新版(对账匹配)
    getCalculateLists(param){
      return http.get('/manage/member/lists',param)
    },
    getMatchingRules(param){
      return http.post('/manage/member/searchCalculate',param)
    },
    addCalculateInfos(param){
      return http.post('/manage/member/addCalculate',param)
    },
    clearCalculateTables(){
      return http.get('/manage/member/ClearTable')
    },
    batchModificationDates(param){
      return http.post('/manage/member/batchModification',param)
    },
    updateRuleDates(param){
      return http.post('/manage/member/updateCalculateDate',param)
    },
    updateRestoreDates(id){
      return http.post('/manage/member/updateRestoreDates',{id})
    },
    updateBatchInfos(param){
      return http.post('/manage/member/updateBatchModification',param)
    },
    updateRuleIdDates(param){
      return http.post('/manage/member/updateRuleIdDates',param)
    },
    eliminateClienIdInfos(param){
      return http.post('/manage/member/eliminateClienIdInfos',param)
    },
    
    
    //(旧版)对账匹配
    getCalculateList(param){
      return http.get('/manage/calculate/list',param)
    },
    addCalculateInfo(param){
      return http.post('/manage/calculate/addCalculate',param)
    },
    searchCalculate(param){
      return http.post('/manage/calculate/searchCalculate',param)
    },
    updateRuleDate(param){
      return http.post('/manage/calculate/updateCalculateDate',param)
    },
    updateRestoreDate(id){
      return http.post('/manage/calculate/updateRestoreDate',{id})
    },
    updateRuleIdDate(param){
      return http.post('/manage/calculate/updateRuleIdDate',param)
    },
    eliminateClienIdInfo(param){
      return http.post('/manage/calculate/eliminateClienIdInfo',param)
    },
    batchModificationDate(param){
      return http.post('/manage/calculate/batchModification',param)
    },
    updateBatchInfo(param){
      return http.post('/manage/calculate/updateBatchModification',param)
    },
    ClearCalculateTable(){
      return http.get('/manage/calculate/ClearTable')
    },
    temporaryStorageDate(param){
      return http.post('/manage/calculate/temporaryStorage',param)
    },



    //对账数据
    getConfirmLists(param){
      return http.post('/manage/member/confirm',param)
    },
    addConfirmInfos(param){
      return http.post('/manage/member/add',param)
    },
    delConfirmInfos(id){
      return http.post('/manage/member/del',{id})
    },
    addBatchImport(param){
      return http.post('/manage/member/confirm_import',param)
    },
    //返佣记录
    getRakeBackLists(param){
      return http.post('/manage/member/rebate',param)
    },
    getRakeBackListDetails(param){
      return http.post('/manage/member/rebate_details',param)
    },
    addRakeBackInfos(param){
      return http.post('/manage/member/rebate_import',param)
    },
    

    // 凭证数据
    getProofList(param){
      return http.get('/manage/member/list',param)
    },
    updateProof(param){
      return http.post('/manage/member/update',param)
    },
    searchCard(param){
      return http.get('/manage/member/card_list',param)
    },
    searchStore(param){
      return http.get('/manage/member/store_list',param)
    },


    //日志
    getLogLists(param){
      return http.get('/manage/member/log',param)
    },



    //组件 - money
    getMoneyList(param){
      return http.get('/manage/money/list',param)
    },
    getMoneyConfirm(param){
      return http.get('/manage/money/confirm',param)
    },
    getMoneyConfirmList(param){
      return http.get('/manage/money/confirmList',param)
    },
    getrakebackSingleList(param){
      return http.post('/manage/money/RakebackSingleList',param)
    },
    getCalculateProportion(param){
      return http.post('/manage/money/calculateProportion',param)
    },

  //待定 ()
  // moneyNoticeInfo(){
  //   return http.get('/manage/money/notice')
  // },
  // getClientMortgageDetail({crm_client_id}){
  //   return http.get('/manage/client/mortgageDetail',{crm_client_id})
  // },
  // getMortgageBystagesQueryList({crm_client_id})
  // {
  //   return http.get('/manage/client/mortgageStages',{crm_client_id})
  // },
  


  //新版
    getBankList(pid){
      return http.get('/manage/marketing/bank',{pid})
    },
    addBankInfo(param){
      return http.post('/manage/marketing/bank_add',param)
    },
    delBankInfo(id){
      return http.post('/manage/marketing/bank_del',{id})
    },
    getSignList(){
      return http.post('/manage/marketing/sign')
    },

    getProductList(param){
      return http.get('/manage/marketing/product',param)
    },
    // addProductInfo(param){
    //   return http.post('/manage/marketing/product_add',param)
    // },


  //产品中心

    //银行
    // addBankInfo(param){
    //   return http.post('/manage/bank/add',param)
    // },
    // getBankList(pid){
    //   return http.get('/manage/bank/list',{pid})
    // },
    getBranchList(pid){
      return http.get('/manage/bank/branch',{pid})
    },
    // delBankInfo(id){
    //   return http.get('/manage/bank/del',{id})
    // },
    // getSignList(){
    //   return http.get('/manage/bank/sign')
    // },

    //产品
    addProductInfo(param){
      return http.post('/manage/product/add',param)
    },
    UpdateProductStatus(param){
      return http.post('/manage/product/update',param)
    },

    //渠道
    addChannelInfo(param){
      return http.post('/manage/channel/add',param)
    },
    getChannelList(param){
      return http.get('/manage/channel/list',param)
    },
    getCorpUserTree(param){
      return http.get('/manage/channel/userTree',param)
    },
    delChannelInfo(id){
      return http.get('/manage/channel/del',{id})
    },
    getCancelAssociation(param){
      return http.get('/manage/channel/cancelAssociation',param)
    },










  getUserList(param){
    return http.get('/manage/user/list',param)
  },
  addUserInfo(param){
    return http.post('/manage/user/add',param)
  },
  delUserInfo(id){
    return http.post('/manage/user/del',{id})
  },






  //系统设置
  getRoleAndCorp(){
    return http.get('/manage/admin/corp')
  },
  getAccountList(){
    return http.get('/manage/admin/list')
  },
  addAdminAccount(param){
    return http.post('/manage/admin/add',param)
  },
  editAdminPassword(param){
    return http.post('/manage/admin/editPwd',param)
  },
  delAdminAccount(id){
    return http.post('/manage/admin/del',{id})
  },
  updateAccountRole(param){
    return http.post('/manage/admin/role',param)
  },

  addSystemArea(param){
    return http.post('/manage/area/addArea',param)
  },
  getSystemArea(pid){
    return http.get('/manage/area/areaList',{pid})
  },
  getSystemAreas(param){
    return http.get('/manage/area/areaLists',param)
  },
  getTreeArea(param){
    return http.get('/manage/area/getTreeArea',param)
  },
  updateSystemArea(param){
    return http.post('/manage/area/updateArea',param)
  },
  delSystemArea(id){
    return http.delete(`/manage/area/delArea/${id}`)
  },
  getCorpType(){
    return http.get('/manage/corp/type')
  },
  getCorpList(param){
    return http.get('/manage/corp/list',param)
  },
  getCorpSelect(param){
    return http.get('/manage/corp/getCorp',param)
  },
  addSystemCorp(param){
    return http.post('/manage/corp/add',param)
  },
  delSystemCorp(id){
    return http.post('/manage/corp/del',{id})
  },
  getCorpLists(param){
    return http.get('/manage/corp/agency',param)
  },
  getSystemPrivilege(param){
    return http.get('/manage/privilege/list',param)
  },
  addSystemPrivilege(param){
    return http.post('/manage/privilege/add',param)
  },
  delSystemPrivilege(id){
    return http.get('/manage/privilege/del',{id})
  },
  getMyIcon(){
    return http.get('/manage/privilege/icon')
  },
  getMenus(param){
    return http.get('/manage/privilege/menus',param)
  },
  getRoleList(){
    return http.get('/manage/role/list')
  },
  addSystemRole(param){
    return http.post('/manage/role/add',param)
  },
  delSystemRole(id){
    return http.get('/manage/role/del',{id})
  },
  getSystemLogList(param){
    return http.post('/manage/system/list',param)
  },
  
  

  //渠道进件
  getOutsideUser(param){
    return http.post('/manage/outside/user',param)
  },
  getOutsideClient(param){
    return http.post('/manage/outside/client',param)
  },
  getOutsideUserListInfo(param)
  {
    return http.get('/manage/outside/userClientList',param)
  },
  updateOutsideUserStatus(param){
    return http.post('/manage/outside/updateStatus',param)
  },


  


//新版（改版） -- 房贷管理
  //老版
    // addMortgagelList(param){
    //   return http.post('/manage/mortgage/adds',param)
    // },
  //房贷公共方法
    updateStatus(param){
      return http.post('/manage/mortgage/updateStatus',param)
    },
    getHouseUserTree(param){
      return http.get('/manage/mortgage/userTree',param)
    },
    // getPactIdLists(param){
    //   return http.get('/manage/mortgage/pact',param)
    // },


    getPactIdList(param){
      return http.get('/manage/mortgage/pact',param)
    },
    getAreaMap({id}){
      return http.post('/manage/mortgage/map_address',{id})
    },
    getUpdateStatus(param){
      return http.post('/manage/mortgage/getUpdateStatus',param)
    },
    getHouseMoneyList(id){
      return http.get('/manage/mortgage/houseMoney',{id})
    },
    getSignManagerList(param){
      return http.get('/manage/mortgage/signingList',param)
    },
    getSummaryList(param){
      return http.get('/manage/mortgage/summary',param)
    },
    getStatuswhereList(param){
       return http.post('/manage/mortgage/status_list',param)
    },
    getHouseEdits(param){
      return http.get('/manage/mortgage/edit',param)
    },
    getHouseCityLists(param){
      return http.post('/manage/mortgage/city',param)
    },
  //签约中心
    getMortgageSignList(param){
      return http.post('/manage/mortgage/index',param)
    },
    addMortgageSignInfo(param){
      return http.post('/manage/mortgage/increase',param)
    },
    delMortgageSignInfo(id){
      return http.post('/manage/mortgage/recycle',{id})
    },
  //返佣比例
    getMortgageRebateList(param){
      return http.post('/manage/mortgage/rebate',param)
    },
    addHouseRebate(param){
      return http.post('/manage/mortgage/rebate_add',param)
    },
    getRebateLogList(param){
      return http.post('/manage/mortgage/logList',param)
    },
  //渠道认证
    getMortgageChannelList(param){
      return http.post('/manage/mortgage/channel',param)
    },
    addMortgageChannelInfo(param){
      return http.post('/manage/mortgage/channelAdd',param)
    },
    delMortgageChannelInfos(id){
      return http.get('/manage/mortgage/channelDel',{id})
    },
  //分配数据 公众号  【用的是同一个方法】
    getMortgageClientList(param){
      return http.get('/manage/mortgage/ClientList',param)
    },
    addClientAddInfo(param){
      return http.post('/manage/mortgage/clientAdd',param)
    },
    delClientAddInfo(id){
      return http.post('/manage/mortgage/clientDel',{id})
    },
    getTransactionManagerList(param){
      return http.get('/manage/mortgage/transactionManager',param)
    },
    getMortgageLogs(param){
      return http.get('/manage/mortgage/logs',param)
    },
  //房源信息
    getMortgageHousingList(param){
      return http.get('/manage/mortgage/housingList',param)
    },

  //房贷业务
    getMortgageList(param){
      return http.post('/manage/mortgage/list',param)
    },
    getMortgageDetail(param){
      return http.get('/manage/mortgage/detail',param)
    },
    getMortgageLogList(param){
      return http.post('/manage/mortgage/log',param)
    },
    getDataChangeLogList(param){
      return http.post('/manage/mortgage/data_log',param)
    },
    getFinanceChangeLogList(param){
      return http.post('/manage/mortgage/finance_log',param)
    },
    getHouseWhereList(param){
      return http.post('/manage/mortgage/batchHouse',param)
    },
    updateHouseBatchBusiness(param){
      return http.post('/manage/mortgage/addBatchHouse',param)
    },
    editRateBatchImport(param){
      return http.post('/manage/mortgage/confirm_import',param)
    },
  //分期列表
    getMortgageBystagesList(param){
      return http.post('/manage/mortgage/bystages',param)
    },

    //监管机构
    getMortgageSupervisionList(param){
      return http.get('/manage/mortgage/supervision',param)
    },
    addMortgageSupervisionInfo(param){
      return http.post('/manage/mortgage/add_supervision',param)
    },
    // delMortgageSupervisionInfo(id){
    //   return http.post('/manage/mortgage/del_supervision',{id})
    // },


  //房贷经理
    // getMortgageUser(param){
    //   return http.post('/manage/mortgage/user',param)
    // },
    getMortgageUsers(param){
      return http.post('/manage/mortgage/getUserLists',param)
    },
    addMortgageUserInfo(param){
      return http.post('/manage/mortgage/add',param)
    },
    delMortgageUserInfo(id){
      return http.post('/manage/mortgage/del',{id})
    },
    updateMortgageUserActivate(param){
      return http.post('/manage/mortgage/edit',param)
    },
    getRoleAndCorps(){
      return http.get('/manage/mortgage/corp')
    },
    getBankTreeDatas(param){
      return http.get('/manage/mortgage/banktree',param)
    },

    
  //地图
    getProvinceList(param){
      return http.get('/manage/mortgage/getProvinceList',param)
    },
    getDistrictList(id){
      return http.get('/manage/mortgage/getDistrictList',{id})
    },
    getHouses(params){
      return http.get('/manage/mortgage/getHouses',{params})
    },
  // 汇总
    getMortgageBankSelect(param){
      return http.get('/manage/mortgage/bank_index',param) 
    },
    getMortgageSummaryList(param){
      return http.get('/manage/mortgage/summary_list',param) 
    },


//新版（改版） -- 意数宝

  //意数产品
    getAppletProduct(param){
      return http.post('/manage/applet/index',param)
    },
    addAppletProductInfo(param){
      return http.post('/manage/applet/add',param)
    },
    delAppletProductInfo(id){
      return http.post('/manage/applet/del',{id})
    },

  //注册用户
    getAppletYsbUser(param){
      return http.post('/manage/applet/ysbuser',param)
    },
    getUpdateYsbUser(param){
      return http.post('/manage/applet/update',param)
    },
    getAppeltYsbUserListInfo(param){
      return http.get('/manage/applet/ysbUserInvite',param)
    },
    getAppeltYsbUserList(param){
      return http.get('/manage/applet/ysbUserInfo',param)
    },

  //进件数据
    getAppletYsbList(param){
      return http.post('/manage/applet/ysbList',param)
    },

  //返佣
    getAppletYsbRebate(param){
      return http.post('/manage/applet/ysbRebate',param)
    },
    addYsbRebateList(param){
      return http.post('/manage/applet/ysbRebateadd',param)
    },

  //打款
    getAppletYsbPayment(param){
      return http.post('/manage/applet/ysbPayment',param)
    },
    addYsbPayList(param){
      return http.post('/manage/applet/addYsbPayList',param)
    },
    updateYsbPayment(param){
      return http.post('/manage/applet/updateYsbPayment',param)
    },









  //老版 - 意数宝
  getAppletCorpQrocdeList(param)
  {
    return http.post('/manage/applet/qrCodeList',param)
  },
  addAppletCorpQrocde(param){
    return http.post('/manage/applet/qrAdd',param)
  },
  delAppletCorpQrocde(id){
    return http.post('/manage/applet/qrDel',{id})
  },
  getAppeltYsbUserApplicationList(param)
  {
    return http.get('/manage/applet/ysbUserApplication',param)
  },
  getAppeltProductExplainInfo(param){
    return http.get('/manage/applet/ProductExplain',param)
  },

/**
 * 新版（改版） -- 宝葫芦
 */

  //公共方法
  updateAppletStatus(param){
    return http.post('/manage/applet/updateStatus',param)
  },
  getCityLists(param){
    return http.post('/manage/applet/city',param)
  },
  getPackageLists(param){
    return http.post('/manage/applet/packages',param)
  },
  getStylesLists(param){
    return http.post('/manage/applet/decorationStyle',param)
  },

  
  //邀请码
  getBhlBusinessCode(param){
    return http.post('/manage/applet/bhlBusinessCode',param)
  },
  addAppletBhlBusinessocde(param){
    return http.post('/manage/applet/bhlBusinessAdd',param)
  },

  //配置项
  getAppletDrainageDecorationList(param){
    return http.post('/manage/applet/decorations',param)
  },
  getAppletDrainageDecorationAdd(param){
    return http.post('/manage/applet/addDecorations',param)
  },
  getAppletDrainageDecorationDel(id){
    return http.post('/manage/applet/DelDecorations',{id})
  },

  //积分项
  getAppletBhlIntegralsList(param){
    return http.post('/manage/applet/bhlIntegral',param)
  },
  getAppletBhlIntegralsAdd(param){
    return http.post('/manage/applet/bhlAddIntegral',param)
  },
  getAppletBhlIntegralsDel(id){
    return http.post('/manage/applet/bhlDelIntegral',{id})
  },


  //广告位
  getAppletBhlAdList(param){
    return http.post('/manage/applet/bhlAdList',param)
  },
  getAppletBhuAdAdd(param){
    return http.post('/manage/applet/bhlAdAdd',param)
  },
  getAppletBhuAdDel(id){
    return http.post('/manage/applet/bhlDelAd',{id})
  },

  //设计师
    // (推荐客户)
    getAppeltBhlCustomerListInfo(param){
      return http.get('/manage/applet/bhlCustomerInvite',param)
    },  
    getAppeltDesignerList(param){
      return http.post('/manage/applet/designer',param)
    },
    updateAppletDesigner(param){
      return http.post('/manage/applet/updatedesigner',param)
    },
    getAppeltIntegralList(param){
      return http.post('/manage/applet/integral',param)
    },

  //量房客户
    getAppeltHouseList(param){
      return http.post('/manage/applet/house',param)
    },
    getAppeltHouseAdd(param){
      return http.post('/manage/applet/houseadd',param)
    },
  
  //推荐客户
    getAppletRecommendList(param){
      return http.post('/manage/applet/bhlRecommendList',param)
    },
    addAppletBhlRecommend(param){
      return http.post('/manage/applet/bhlRecommendAdd',param)
    },
    delAppletBhlRecommend(id){
      return http.post('/manage/applet/bhlRecommendDel',{id})
    },

  //申述
    getAppletComplainList(param){
      return http.post('/manage/applet/bhlComplainList',param)
    },
    addAppletBhlComplain(param){
      return http.post('/manage/applet/bhlComplainAdd',param)
    },
    delAppletBhlComplain(id){
      return http.post('/manage/applet/bhlComplainDel',{id})
    },




  getAppeltDesignerListStatus(param)
  {
    return http.post('/manage/applet/designerStatus',param)
  },
  updateAppletDesignerDistribution(param)
  {
    return http.post('/manage/applet/distribution',param)
  },
  getAppeltInviteList(param)
  {
    return http.post('/manage/applet/invite',param)
  },
  getFollowUpLogLists(id)
  {
    return http.post('/manage/applet/followuplog',{id})
  },
  getClassifyList(pid){
    return http.get('/manage/questions/list',{pid})
  },
  addClassifyInfo(param){
    return http.post('/manage/questions/add',param)
  },
  delClassifyInfo(id){
    return http.get('/manage/questions/del',{id})
  },
  getProblemList(param){
    return http.post('/manage/questions/problem',param)
  },
  addFaqQuestion(param){
    return http.post('/manage/questions/addProblem',param)
  },
  delFaqQroblemInfo(id){
    return http.get('/manage/questions/delProblem',{id})
  },
  getFaqTypeSelect(param){
    return http.get('/manage/questions/type',param)
  },
  getCategorySelect(param){
    return http.get('/manage/questions/categoryselect',param)
  },
  getCategorySelects(param){
    return http.get('/manage/questions/categorySelects',param)
  },
  getCrmAdminSelect(param){
    return http.get('/manage/questions/adminSelect',param)
  },
  addTypeInfo(param){
    return http.post('/manage/questions/addType',param)
  },
  getTypeList(param){
    return http.post('/manage/questions/typeList',param)
  },
  delFaqTypeInfo(id){
    return http.get('/manage/questions/delType',{id})
  },
  



/**
 * 新版 活动管理 模块
 */
    // 公共方法
    getAdminList(param){
      return http.get('/manage/activity/adminUser',param)
    },

    // 活动名称
    getActivityList(param){
      return http.post('/manage/activity/list',param)
    },
    addTestDrive(param){
      return http.post('/manage/activity/addTestDrive',param)
    },
    delTestDrive(id){
      return http.post('/manage/activity/delTestDrive',{id})
    },
    getTestdriveListInfo(param){
      return http.get('/manage/activity/activityCategoryList',param)
    },

    //活动数据
    getActivityDataList(param){
      return http.post('/manage/activity/activityData',param)
    },


  //考试
    //公共
    getExamReferenceSharedList(param){
      return http.get('/manage/exam/sharedReferenceList',param)
    },

  getExamList(param){
    return http.get('/manage/exam/list',param)
  },
  addExamData(param){
    return http.post('/manage/exam/exam_add',param)
  },
  delExamInfo(id){
    return http.post('/manage/exam/exam_del',{id})
  },

  addExamQuestion(param){
    return http.post('/manage/exam/addQuestion',param)
  },
  getExamQuestion(param){
    return http.get('/manage/exam/question',param)
  },
  delExamQuestion(param){
    return http.post('/manage/exam/delQuestion',param)
  },
  addExamPaper(param){
    return http.post('/manage/exam/addPaper',param)
  },
  getPaperList(param){
    return http.get('/manage/exam/paper',param)
  },
  getPaperAnswerList(param){
    return http.get('/manage/exam/answerList',param)
  },
  getAnswerDetail(param){
    return http.get('/manage/exam/answerDetail',param)
  },
  updateAnswerDetail(param){
    return http.post('/manage/exam/updateAnswer',param)
  },
  getQuestionsByExamIds(exam_ids)
  {
    return http.post('/manage/exam/examinationPaper',{exam_ids})
  },



  // 参考人员
  getExamReferenceList(param){
    return http.get('/manage/exam/reference',param)
  },
  addExamReferenceData(param){
    return http.post('/manage/exam/reference_add',param)
  },
  delExamReferenceInfo(id){
    return http.post('/manage/exam/reference_del',{id})
  },


  //造假刷剧
  getExamCounterfeitingList(param){
    return http.post('/manage/exam/compliance_details',param)
  },

  //渠道建档
  getArchiveUser(param){
    return http.post('/manage/archive/index',param)
  },
  getArchiveEmployee(){
    return http.get('/manage/archive/employee')
  },
  updateArchiveUser(param){
    return http.post('/manage/archive/updateFiling',param)
  },
  getBatchList(param){
    return http.get('/manage/archive/batch',param)
  },
  getIntegralList(param){
    return http.get('/manage/archive/integral',param)
  },
  getRevokeIntegral(id){
    return http.get('/manage/archive/revokeintegral',{id})
  },
  getArchiveAccountList(param){
    return http.get('/manage/archive/account',param)
  },
  addIntegralList(param){
    return http.post('/manage/archive/add',param)
  },
  updateArchiveAccountRegister(param){
    return http.post('/manage/archive/updateRegister',param)
  },
  

  //财务模块
  getFinanceChannelList(param){
    return http.post('/manage/finance/channel',param)
  },
  addFinanceChannelInfo(param){
    return http.post('/manage/finance/channelAdd',param) 
  },
  delFinanceChannelInfo(id){
    return http.get('/manage/finance/channelDel',{id})
  },
  getFinancePactList(param){
    return http.post('/manage/finance/pact',param)
  },
  addFinancePactInfo(param){
    return http.post('/manage/finance/pactAdd',param) 
  },
  delFinancePactInfo(id){
    return http.get('/manage/finance/pactDel',{id})  
  },
  getFinanceRecordList(param){
    return http.post('/manage/finance/record',param) 
  },
  getFinanceBalanceList(param){
    return http.post('/manage/finance/balance',param)
  },
  addFinanceBalanceInfo(param){
    return http.post('/manage/finance/balanceAdd',param) 
  },
  getFinanceBalanceAdjustData(param){
    return http.post('/manage/finance/balanceAdjust',param)
  },
  updatePersonAdjustMoney(param){
    return http.post('/manage/finance/balanceAdjustEdit',param)
  },
  addFinanceBalancePrestore(param){
    return http.post('/manage/finance/prestoreAdd',param) 
  },
  getFinancePrestoreList(param){
    return http.post('/manage/finance/prestore',param)
  },
  delFinancePrestoreInfo(id){
    return http.get('/manage/finance/prestoreDel',{id})
  },
  getFinancePactLogs(pactId){
    return http.get('/manage/finance/pactLogs',{pactId})
  },
  delFinanceBalanceInfo(id){
    return http.get('/manage/finance/balanceDel',{id})  
  },
  addFinanceAccountInfo(param){
    return http.post('/manage/finance/accountAdd',param) 
  },
  getFinanceAccountLogList(param){
    return http.post('/manage/finance/accountLog',param) 
  },
  
  
  

  //财务管理公共部分
  getFinanceChannel(){
    return http.post('/manage/finance/selectChannel')
  },
  getFinancePact(){
    return http.post('/manage/finance/selectPact')
  },
  getFinanceCorporateDetails(param){
    return http.get('/manage/finance/corporate',param)
  },
  getFinancePersonalDetails(param){
    return http.get('/manage/finance/personal',param)
  },
  getFinanceRakebackDetails(param){
    return http.post('/manage/finance/rake_back',param)
  },
  getFinanceCorporateFreezeDetails(param){
    return http.get('/manage/finance/freeze',param)
  },
  getFinanceMortgageDetails(param){
    return http.get('/manage/finance/mortgage',param)
  },
  updateFinanceStatus(param){
    return http.post('/manage/finance/updateStatus',param)
  },
  getFinanceApprovalList(param){
    return http.post('/manage/finance/approval',param) 
  },
  getFinancePactRateList(id){
    return http.get('/manage/finance/rate_list',{id}) 
  },
  getFinanceManualRateList(param){
    return http.get('/manage/finance/manual_rate_list',param) 
  },
  getFinanceManualRateWhether(param){
    return http.post('/manage/finance/manual_rate_whether',param) 
  },
  getFinanceRoleAndCorp(){
    return http.get('/manage/finance/corp')
  },
  

  //修改费率的
  getFinancePactEdits(param){
    return http.post('/manage/finance/edit_corporate_rate',param) 
  },
  
  //网站管理
  getWebsiteArticleList(param){
    return http.post('/manage/website/article',param)
  },
  addWebsiteArticle(param){
    return http.post('/manage/website/articleAdd',param)
  },
  delWebsiteArticle(param){
    return http.post('/manage/website/articleDel',param)
  },
  delWebsiteArticleImg(articleId){
    return http.post('/manage/website/imgDel',{articleId})
  },

  getWebsiteWorkList(param){
    return http.post('/manage/website/work',param)
  },
  addWebsiteWork(param){
    return http.post('/manage/website/workAdd',param)
  },
  delWebsiteWork(param){
    return http.post('/manage/website/workDel',param)
  },
  getWebsiteVitaeList(param){
    return http.post('/manage/website/vitae',param)
  },
  updateWebsiteVitae(param){
    return http.post('/manage/website/vitaeEdit',param)
  },

  //公共部分
  getOutsideStatus(){
    return http.get('/common/outsideStatus')
  },
  getBankTreeData(param){
    return http.get('/common/banktree',param)
  },
  // getBankTreeDatas(param){
  //   return http.get('/common/bankTrees',param)
  // },
  getProvinceTreeData(param){
    return http.get('/common/provincetree',param)
  },
  getAreaBankProduct(param){
    return http.get('/common/areatree',param)
  },
  getChannelTree(){
    return http.get('/common/channeltree')
  },
  getStatus(){
    return http.get('/common/status')
  },
  getSignUser(){
    return http.get('/common/signUser')
  },
  addWorkList(param){
    return http.post('/common/wxwork/addWorkList',param)
  },
  getWorkList(param){
    return http.get('/common/wxwork/workList',param)
  }
}
export default api